import { ActionTree } from 'vuex'
import * as types from './types'
export default <ActionTree<appbase.state.AppbaseState, RootState>>{
}
